import { defineAsyncComponent } from 'vue';

export { default as PriceListModal } from './components/PriceListModal';

export const priceListMicroFrontends = {
	PriceListModal: defineAsyncComponent(
		() => import('./components/PriceListModal')
	),
};
